<div>
  <div class="title title--big">Участки</div>
</div>

<div class="pos-r">
  <app-loader *ngIf="tableBlock.sectorsLoading"></app-loader>

  <div class="mt-32 pt-8">
    <app-role-access [action]="'disable'" [permission]="'sector.add'" [placement]="'bottom-left'">
      <button data-role-element type="button" class="button" id="appCreatePlot" (click)="createSector()">Добавить участок</button>
    </app-role-access>
  </div>

  <app-sectors-filter [stateParams]="stateParams" [filter]="filter" [data]="data"></app-sectors-filter>
  <app-sectors-list [filter]="filter" [data]="data" [paginationBlock]="paginationBlock" [tableBlock]="tableBlock"></app-sectors-list>
</div>
